export enum ReportSection {
  PLOTS = 'plots',
  RESTRICTIONS = 'restrictions',
  MUNICIPALITY_LAW = 'municipalityLaw',
  CANTON_LAW = 'cantonLaw',
  BUILDINGS = 'buildings',
  SUMMARY = 'summary',
  SITUATION = 'situation',
  UTILIZATION = 'utilization',
  AREAS = 'areas',
  DIMENSIONS = 'dimensions',
  DIMENSION_IMAGES = 'dimensionImages',
  BUILDING_UNITS = 'buildingUnits',
  CHECKLIST = 'checklist',
  COSTS = 'costs',
  INCOMES = 'incomes',
  DATA_OVERVIEW = 'dataOverview',
}
